import React, { useEffect } from 'react';

const VaticanNewsWidget = () => {
  useEffect(() => {
    // Create the script element
    const script = document.createElement('script');
    script.src = "https://www.vaticannews.va/widget.js";
    script.async = true;

    // Append it to the body
    document.body.appendChild(script);

    // Cleanup: remove the script if the component unmounts
    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <vaticannews-widget 
      lang="es" 
      fontSize="14" 
      carouselVideoAuto="true" 
      carouselVideoTime="medium">
    </vaticannews-widget>
  );
};

export default VaticanNewsWidget;